import dayjs from 'dayjs';
import { User, Job } from '@core/generated/gql-types';
import {
  TemplateTerm,
  useTemplateStore,
} from '@core/template/useTemplateStore';

interface WorkerApplicationProps {
  worker: User;
  job: Job;
  onAssignWorker: (worker: User) => void;
}

const WorkerApplication = ({
  worker,
  job,
  onAssignWorker,
}: WorkerApplicationProps) => {
  const jobInPast = job?.startDate
    ? dayjs(parseInt(job.startDate, 10)).isBefore(dayjs())
    : true;
  const { getTerm } = useTemplateStore();

  return (
    <div className="flex w-full items-center justify-between gap-2 rounded-md bg-white p-2">
      <div className="flex items-center gap-2">
        <div className="flex h-10 w-10 items-center overflow-hidden rounded-full bg-gray-100">
          {worker?.profilePictureUrl ? (
            <img
              src={worker.profilePictureUrl}
              alt={worker?.firstName + ' ' + worker?.lastName}
              className="h-10 w-10 object-contain"
            />
          ) : (
            <div className="h-10 w-10 rounded-full bg-gray-200" />
          )}
        </div>
        <div className="flex flex-col">
          <p className="text-sm font-medium text-gray-900">{`${worker?.firstName} ${worker?.lastName}`}</p>
          <p className="text-sm text-gray-400">
            {job?.classification?.name || 'Job classification not set'}
          </p>
        </div>
      </div>
      <button
        className={`cursor-pointer rounded-lg bg-blue-600 px-2 py-1 text-white ${jobInPast ? 'cursor-not-allowed opacity-50' : ''} hover:bg-blue-500`}
        type="button"
        title={
          !worker
            ? `No ${getTerm(TemplateTerm.WORKER, false)} selected`
            : `Assign ${getTerm(TemplateTerm.WORKER, false)}`
        }
        onClick={() => {
          onAssignWorker(worker);
        }}
      >
        Assign
      </button>
    </div>
  );
};

export default WorkerApplication;
